import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AccountDto } from '../../data/models/account-dto';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers:[MessageService]
})
export class DashboardComponent implements OnInit {
  accountDetails: AccountDto;
  breadItems: MenuItem[];

  constructor(private authService: AuthService, private accountService: AccountService, private messageService: MessageService) { }

  ngOnInit(): void {

    this.breadItems = [
      { label: 'Home' ,routerLink: '/' },
    ];
  }

 

}
